// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vJZ5","index":"styles_index__1BeIH"};